import { useGetFetch } from '../reactQuery';
import { STEP_API } from '../../../constant/api_url';
import { Input } from '../../../types/input.types';

export const useConnectedInputsToStep = (id: string | number) =>
  useGetFetch<Input[]>(`${STEP_API}/${id}/input`);
